import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import WebinarForm from '../../components/Webinar/WebinarForm';
import BreadCrumb from '../../components/Breadcrumb';
import * as actions from '../../redux/actions/actions-webinar';

class addWebinar extends Component {
  constructor(props) {
    super(props);

    if (props.match.params.id !== '0') {
      props.setForm(props.match.params.id);
    } else {
      props.resetForm();
    }
    this.state = {};
  }


  handleSubmit = (FormData) => {
    this.props.saveWebinar(FormData);
  }


  render() {
    return (
      <>
        <div className="container">
          <BreadCrumb currentPage="Webinar" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    { this.props.match.params.id !== '0'
                      ? <span className="fa fa-pencil-alt cardTitle"> Edit Webinar</span>
                      : <span className="fa fa-plus-square cardTitle"> Create New Webinar</span>}
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fa fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                {/* <h3>fnkbfgjbfgb</h3> */}
                <WebinarForm
                  onSubmit={this.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

addWebinar.propTypes = {
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  saveWebinar: PropTypes.func
};

addWebinar.defaultProps = {
  formLoading: null,
  formError: null,
  saveWebinar: null
};

const mapStateToProps = ({ webinar }) => ({});

const mapDispatchToProps = (dispatch) => ({
  saveWebinar: (data) => dispatch(actions.saveWebinar(data)),
  setForm: (id) => dispatch(actions.editWebinar(id)),
  resetForm: () => dispatch(actions.resetForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(addWebinar);
